import React from "react";

let Loading = require("./loading");
let SaveForLaterSlat = require("./moderation-save-for-later-slat");

class ModerationSaveForLaterSlats extends React.Component {
    render() {
        let uploadArray = [];

        if (this.props.batch.uploads.length > 0) {
            this.props.batch.uploads.forEach(upload => {
                uploadArray.push(
                    <SaveForLaterSlat key={upload.id} upload={upload} />
                );
            });
        } else {
            if (this.props.batch.result === "SEARCH_SAVED_UPLOADS_SUCCESS") {
                return <div className="no-results"><h3>No Results</h3></div>;
            } else {
                if (this.props.batch.result === "FETCH_SAVED_UPLOADS_SUCCESS") {
                    return (
                        <div className="no-results">
                            There aren't any saved uploads to review at the moment.
                        </div>
                    );
                } else {
                    return <Loading />;
                }
            }
        }

        return (
            <section className="save-for-later-slats">
                {uploadArray}
            </section>
        );
    }
}

module.exports = ModerationSaveForLaterSlats;
